import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import InnerHTML from '@Components/InnerHTML';

function ConditionsInfoTooltip({
  ariaLabel,
  children,
  className = '',
  dataE2e = 'conditions-info-tooltip',
  placement = 'bottom-start',
  stopClickPropagation = false,
  width,
}) {
  const tooltip = (
    <Flyout
      placement={placement}
      flyout={<InnerHTML tag="div" className="rx-info-flyout__content" html={children} />}
      className="u-els-display-inline-block"
      width={width}
      trigger="click"
      pointerType="primary"
      showCloseButton
      shouldCloseOnESC>
      <ButtonWithIcon
        data-e2e={dataE2e}
        sprite="InformationOutlineCircle"
        iconOnly
        type="link"
        linkIconSize="xs"
        className={className}
        aria-label={ariaLabel}>
        {ariaLabel}
      </ButtonWithIcon>
    </Flyout>
  );

  if (!stopClickPropagation) {
    return tooltip;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <span onClick={(e) => e.stopPropagation()}>{tooltip}</span>
  );
}

ConditionsInfoTooltip.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataE2e: PropTypes.string,
  placement: PropTypes.string,
  stopClickPropagation: PropTypes.bool,
  width: PropTypes.string,
};

export default ConditionsInfoTooltip;
